import type { DefaultTranslationsObject, Language } from '../types.js'

export const nbTranslations: DefaultTranslationsObject = {
  authentication: {
    account: 'Konto',
    accountOfCurrentUser: 'Konto til nåværende bruker',
    accountVerified: 'Konto bekreftet.',
    alreadyActivated: 'Allerede aktivert',
    alreadyLoggedIn: 'Allerede logget inn',
    apiKey: 'API-nøkkel',
    authenticated: 'Autentisert',
    backToLogin: 'Tilbake til innlogging',
    beginCreateFirstUser: 'Opprett din første bruker for å fortsette.',
    changePassword: 'Endre passord',
    checkYourEmailForPasswordReset:
      'Hvis e-postadressen er knyttet til en konto, vil du motta instruksjoner for å tilbakestille passordet ditt snart. Vennligst sjekk spam- eller søppelpost-mappen din hvis du ikke ser e-posten i innboksen din.',
    confirmGeneration: 'Bekreft generering',
    confirmPassword: 'Bekreft passord',
    createFirstUser: 'Opprett første bruker',
    emailNotValid: 'E-posten er ikke gyldig',
    emailOrUsername: 'E-post eller brukernavn',
    emailSent: 'E-post sendt',
    emailVerified: 'E-post bekreftet med hell.',
    enableAPIKey: 'Aktiver API-nøkkel',
    failedToUnlock: 'Kunne ikke låse opp',
    forceUnlock: 'Tving opplåsing',
    forgotPassword: 'Glemt passord',
    forgotPasswordEmailInstructions:
      'Skriv inn e-postadressen din nedenfor, og vi vil sende deg en e-post med instruksjoner om hvordan du tilbakestiller passordet ditt.',
    forgotPasswordQuestion: 'Glemt passord?',
    forgotPasswordUsernameInstructions:
      'Vennligst skriv inn brukernavnet ditt nedenfor. Instruksjoner om hvordan du tilbakestiller passordet ditt vil bli sendt til e-postadressen som er knyttet til brukernavnet ditt.',
    generate: 'Generer',
    generateNewAPIKey: 'Generer ny API-nøkkel',
    generatingNewAPIKeyWillInvalidate:
      'Å generere en ny API-nøkkel vil <1>ugyldiggjøre</1> den forrige nøkkelen. Er du sikker på at du vil fortsette?',
    lockUntil: 'Lås til',
    logBackIn: 'Logg inn igjen',
    loggedIn: 'For å logge inn med en annen bruker, må du <0>logge ut</0> først.',
    loggedInChangePassword:
      'For å endre passordet ditt, gå til <0>kontoen</0> din og endre passordet der.',
    loggedOutInactivity: 'Du har blitt logget ut på grunn av inaktivitet.',
    loggedOutSuccessfully: 'Du har blitt logget ut.',
    loggingOut: 'Logger ut...',
    login: 'Logg inn',
    loginAttempts: 'Innloggingsforsøk',
    loginUser: 'Logg inn bruker',
    loginWithAnotherUser: 'For å logge inn med en annen bruker, må du <0>logge ut</0> først.',
    logOut: 'Logg ut',
    logout: 'Logg ut',
    logoutSuccessful: 'Utlogging vellykket.',
    logoutUser: 'Logg ut bruker',
    newAccountCreated:
      'En ny konto har blitt opprettet for deg på <a href="{{serverURL}}">{{serverURL}}</a> Klikk på lenken nedenfor eller lim inn URLen i nettleseren din for å bekrefte e-postadressen din: <a href="{{verificationURL}}">{{verificationURL}}</a><br> Etter at du har bekreftet e-postadressen din, kan du logge inn.',
    newAPIKeyGenerated: 'Ny API-nøkkel generert.',
    newPassword: 'Nytt passord',
    passed: 'Autentisering bestått',
    passwordResetSuccessfully: 'Passordet er tilbakestilt.',
    resetPassword: 'Tilbakestill passord',
    resetPasswordExpiration: 'Tilbakestill passordets utløpsdato',
    resetPasswordToken: 'Tilbakestill passordet-token',
    resetYourPassword: 'Tilbakestill passordet ditt',
    stayLoggedIn: 'Forbli logget inn',
    successfullyRegisteredFirstUser: 'Registrerte første bruker vellykket.',
    successfullyUnlocked: 'Låst opp',
    tokenRefreshSuccessful: 'Token-oppdatering vellykket.',
    unableToVerify: 'Kunne ikke bekrefte',
    username: 'Brukernavn',
    usernameNotValid: 'Brukernavnet som er oppgitt er ikke gyldig.',
    verified: 'Bekreftet',
    verifiedSuccessfully: 'Bekreftet',
    verify: 'Bekreft',
    verifyUser: 'Bekreft bruker',
    verifyYourEmail: 'Bekreft e-postadressen din',
    youAreInactive:
      'Du har ikke vært aktiv i en stund, og vil snart bli logget ut automatisk for din egen sikkerhet. Vil du forbli innlogget?',
    youAreReceivingResetPassword:
      'Du mottar denne e-posten fordi du (eller noen andre) har bedt om tilbakestilling av passordet til kontoen din. Klikk på lenken nedenfor, eller lim den inn i nettleseren din for å fullføre prosessen:',
    youDidNotRequestPassword:
      'Hvis du ikke har bedt om dette, kan du ignorere denne e-posten, og passordet ditt vil forbli uendret.',
  },
  error: {
    accountAlreadyActivated: 'Denne kontoen er allerede aktivert.',
    autosaving: 'Det oppstod et problem under automatisk lagring av dokumentet.',
    correctInvalidFields: 'Korriger ugyldige felt.',
    deletingFile: 'Det oppstod en feil under sletting av filen.',
    deletingTitle:
      'Det oppstod en feil under sletting av {{title}}. Sjekk tilkoblingen og prøv igjen.',
    documentNotFound:
      'Dokumentet med ID {{id}} kunne ikke bli funnet. Det kan ha blitt slettet eller aldri eksistert, eller du har kanskje ikke tilgang til det.',
    emailOrPasswordIncorrect: 'E-postadressen eller passordet er feil.',
    followingFieldsInvalid_one: 'Følgende felt er ugyldig:',
    followingFieldsInvalid_other: 'Følgende felter er ugyldige:',
    incorrectCollection: 'Ugyldig samling',
    insufficientClipboardPermissions:
      'Tilgang til utklippstavlen ble nektet. Sjekk utklippstavle-tillatelsene dine.',
    invalidClipboardData: 'Ugyldige utklippstavldata.',
    invalidFileType: 'Ugyldig filtype',
    invalidFileTypeValue: 'Ugyldig filtype: {{value}}',
    invalidRequestArgs: 'Ugyldige argumenter i forespørselen: {{args}}',
    loadingDocument: 'Det oppstod et problem under lasting av dokumentet med ID {{id}}.',
    localesNotSaved_one: 'Følgende språk kunne ikke lagres:',
    localesNotSaved_other: 'Følgende språk kunne ikke lagres:',
    logoutFailed: 'Utlogging mislyktes.',
    missingEmail: 'Mangler e-postadresse.',
    missingIDOfDocument: 'Mangler ID for dokumentet som skal oppdateres.',
    missingIDOfVersion: 'Mangler ID for versjonen.',
    missingRequiredData: 'Mangler påkrevd data.',
    noFilesUploaded: 'Ingen filer ble lastet opp.',
    noMatchedField: 'Ingen matchende felt funnet for "{{label}}"',
    notAllowedToAccessPage: 'Du har ikke tilgang til denne siden.',
    notAllowedToPerformAction: 'Du har ikke tillatelse til å utføre denne handlingen.',
    notFound: 'Den forespurte ressursen ble ikke funnet.',
    noUser: 'Ingen bruker',
    previewing: 'Det oppstod et problem under forhåndsvisning av dokumentet.',
    problemUploadingFile: 'Det oppstod et problem under opplasting av filen.',
    restoringTitle:
      'Det oppstod en feil under gjenoppretting av {{title}}. Vennligst sjekk din tilkobling og prøv igjen.',
    tokenInvalidOrExpired: 'Token er enten ugyldig eller har utløpt.',
    tokenNotProvided: 'Token ikke angitt.',
    unableToCopy: 'Kan ikke kopiere.',
    unableToDeleteCount: 'Kan ikke slette {{count}} av {{total}} {{label}}.',
    unableToReindexCollection:
      'Feil ved reindeksering av samlingen {{collection}}. Operasjonen ble avbrutt.',
    unableToUpdateCount: 'Kan ikke oppdatere {{count}} av {{total}} {{label}}.',
    unauthorized: 'Uautorisert, du må være innlogget for å gjøre denne forespørselen.',
    unauthorizedAdmin: 'Uautorisert, denne brukeren har ikke tilgang til kontrollpanelet.',
    unknown: 'En ukjent feil har oppstått.',
    unPublishingDocument: 'Det oppstod et problem under avpublisering av dokumentet.',
    unspecific: 'En feil har oppstått.',
    unverifiedEmail: 'Vennligst bekreft e-posten din før du logger inn.',
    userEmailAlreadyRegistered: 'En bruker med den oppgitte e-posten er allerede registrert.',
    userLocked: 'Denne brukeren er låst på grunn av for mange mislykkede innloggingsforsøk.',
    usernameAlreadyRegistered: 'En bruker med det oppgitte brukernavnet er allerede registrert.',
    usernameOrPasswordIncorrect: 'Brukernavnet eller passordet som ble oppgitt er feil.',
    valueMustBeUnique: 'Verdien må være unik',
    verificationTokenInvalid: 'Verifiseringskoden er ugyldig.',
  },
  fields: {
    addLabel: 'Legg til {{label}}',
    addLink: 'Legg til lenke',
    addNew: 'Legg til ny',
    addNewLabel: 'Legg til ny {{label}}',
    addRelationship: 'Legg til relasjon',
    addUpload: 'Legg til opplasting',
    block: 'Blokk',
    blocks: 'blokker',
    blockType: 'Blokktype',
    chooseBetweenCustomTextOrDocument:
      'Velg mellom å skrive inn en egen tekst-URL eller å lenke til et annet dokument.',
    chooseDocumentToLink: 'Velg et dokument å lenke til',
    chooseFromExisting: 'Velg fra eksisterende',
    chooseLabel: 'Velg {{label}}',
    collapseAll: 'Skjul alle',
    customURL: 'Egendefinert URL',
    editLabelData: 'Rediger {{label}}-data',
    editLink: 'Rediger lenke',
    editRelationship: 'Rediger relasjon',
    enterURL: 'Skriv inn en URL',
    internalLink: 'Intern lenke',
    itemsAndMore: '{{items}} og {{count}} flere',
    labelRelationship: '{{label}}-relasjon',
    latitude: 'Breddegrad',
    linkedTo: 'Lenket til <0>{{label}}</0>',
    linkType: 'Lenketype',
    longitude: 'Lengdegrad',
    newLabel: 'Ny {{label}}',
    openInNewTab: 'Åpne i ny fane',
    passwordsDoNotMatch: 'Passordene er ikke like.',
    relatedDocument: 'Relatert dokument',
    relationTo: 'Relasjon til',
    removeRelationship: 'Fjern relasjon',
    removeUpload: 'Fjern opplasting',
    saveChanges: 'Lagre endringer',
    searchForBlock: 'Søk etter en blokk',
    searchForLanguage: 'Søk etter et språk',
    selectExistingLabel: 'Velg eksisterende {{label}}',
    selectFieldsToEdit: 'Velg felt som skal redigeres',
    showAll: 'Vis alle',
    swapRelationship: 'Bytte relasjon',
    swapUpload: 'Bytt opplasting',
    textToDisplay: 'Tekst som skal vises',
    toggleBlock: 'Veksle blokk',
    uploadNewLabel: 'Last opp ny {{label}}',
  },
  folder: {
    browseByFolder: 'Bla gjennom etter mappe',
    byFolder: 'Etter mappe',
    deleteFolder: 'Slett mappe',
    folderName: 'Mappenavn',
    folders: 'Mapper',
    folderTypeDescription: 'Velg hvilken type samling dokumenter som skal tillates i denne mappen.',
    itemHasBeenMoved: '{{title}} er flyttet til {{folderName}}',
    itemHasBeenMovedToRoot: '{{title}} er flyttet til rotmappen',
    itemsMovedToFolder: '{{title}} flyttet til {{folderName}}',
    itemsMovedToRoot: '{{title}} flyttet til rotmappen',
    moveFolder: 'Flytt mappe',
    moveItemsToFolderConfirmation:
      'Du er i ferd med å flytte <1>{{count}} {{label}}</1> til <2>{{toFolder}}</2>. Er du sikker?',
    moveItemsToRootConfirmation:
      'Du er i ferd med å flytte <1>{{count}} {{label}}</1> til rotmappen. Er du sikker?',
    moveItemToFolderConfirmation:
      'Du er i ferd med å flytte <1>{{title}}</1> til <2>{{toFolder}}</2>. Er du sikker?',
    moveItemToRootConfirmation:
      'Du er i ferd med å flytte <1>{{title}}</1> til rotmappen. Er du sikker?',
    movingFromFolder: 'Flytte {{title}} fra {{fromFolder}}',
    newFolder: 'Ny mappe',
    noFolder: 'Ingen mappe',
    renameFolder: 'Endre mappenavn',
    searchByNameInFolder: 'Søk etter navn i {{folderName}}',
    selectFolderForItem: 'Velg mappe for {{title}}',
  },
  general: {
    name: 'Navn',
    aboutToDelete: 'Du er i ferd med å slette {{label}} <1>{{title}}</1>. Er du sikker?',
    aboutToDeleteCount_many: 'Du er i ferd med å slette {{count}} {{label}}',
    aboutToDeleteCount_one: 'Du er i ferd med å slette {{count}} {{label}}',
    aboutToDeleteCount_other: 'Du er i ferd med å slette {{count}} {{label}}',
    aboutToPermanentlyDelete:
      'Du er i ferd med å permanent slette {{label}} <1>{{title}}</1>. Er du sikker?',
    aboutToPermanentlyDeleteTrash:
      'Du er i ferd med å permanent slette <0>{{count}}</0> <1>{{label}}</1> fra søppelkassen. Er du sikker?',
    aboutToRestore: 'Du er i ferd med å gjenopprette {{label}} <1>{{title}}</1>. Er du sikker?',
    aboutToRestoreAsDraft:
      'Du er i ferd med å gjenopprette {{label}} <1>{{title}}</1> som et utkast. Er du sikker?',
    aboutToRestoreAsDraftCount: 'Du er i ferd med å gjenopprette {{count}} {{label}} som utkast',
    aboutToRestoreCount: 'Du er i ferd med å gjenopprette {{count}} {{label}}',
    aboutToTrash:
      'Du er i ferd med å flytte {{label}} <1>{{title}}</1> til søppelkurven. Er du sikker?',
    aboutToTrashCount: 'Du er i ferd med å flytte {{count}} {{label}} til søppelkurven',
    addBelow: 'Legg til under',
    addFilter: 'Legg til filter',
    adminTheme: 'Admin-tema',
    all: 'Alle',
    allCollections: 'Alle samlinger',
    allLocales: 'Alle språk',
    and: 'Og',
    anotherUser: 'En annen bruker',
    anotherUserTakenOver: 'En annen bruker har tatt over redigeringen av dette dokumentet.',
    applyChanges: 'Bruk endringer',
    ascending: 'Stigende',
    automatic: 'Automatisk',
    backToDashboard: 'Tilbake til kontrollpanel',
    cancel: 'Avbryt',
    changesNotSaved:
      'Endringene dine er ikke lagret. Hvis du forlater nå, vil du miste endringene dine.',
    clear: 'Tydelig',
    clearAll: 'Tøm alt',
    close: 'Lukk',
    collapse: 'Skjul',
    collections: 'Samlinger',
    columns: 'Kolonner',
    columnToSort: 'Kolonne å sortere',
    confirm: 'Bekreft',
    confirmCopy: 'Bekreft kopi',
    confirmDeletion: 'Bekreft sletting',
    confirmDuplication: 'Bekreft duplisering',
    confirmMove: 'Bekreft flytting',
    confirmReindex: 'Reindekser alle {{collections}}?',
    confirmReindexAll: 'Reindekser alle samlinger?',
    confirmReindexDescription:
      'Dette vil fjerne eksisterende indekser og reindeksere dokumentene i {{collections}}-samlingene.',
    confirmReindexDescriptionAll:
      'Dette vil fjerne eksisterende indekser og reindeksere dokumentene i alle samlinger.',
    confirmRestoration: 'Bekreft gjenoppretting',
    copied: 'Kopiert',
    copy: 'Kopier',
    copyField: 'Kopier felt',
    copying: 'Kopierer',
    copyRow: 'Kopier rad',
    copyWarning:
      'Du er i ferd med å overskrive {{to}} med {{from}} for {{label}} {{title}}. Er du sikker?',
    create: 'Opprett',
    created: 'Opprettet',
    createdAt: 'Opprettet',
    createNew: 'Opprett ny',
    createNewLabel: 'Opprett ny {{label}}',
    creating: 'Oppretter',
    creatingNewLabel: 'Oppretter ny {{label}}',
    currentlyEditing:
      'redigerer for øyeblikket dette dokumentet. Hvis du tar over, blir de blokkert fra å fortsette å redigere, og de kan også miste ulagrede endringer.',
    custom: 'Tilpasset',
    dark: 'Mørk',
    dashboard: 'Kontrollpanel',
    delete: 'Slett',
    deleted: 'Slettet',
    deletedAt: 'Slettet kl.',
    deletedCountSuccessfully: 'Slettet {{count}} {{label}}.',
    deletedSuccessfully: 'Slettet.',
    deleteLabel: 'Slett {{label}}',
    deletePermanently: 'Hopp over søppel og slett permanent',
    deleting: 'Sletter...',
    depth: 'Dybde',
    descending: 'Synkende',
    deselectAllRows: 'Fjern markeringen fra alle rader',
    document: 'Dokument',
    documentIsTrashed: 'Denne {{label}} er søppel og er skrivebeskyttet.',
    documentLocked: 'Låst dokument',
    documents: 'Dokumenter',
    duplicate: 'Dupliser',
    duplicateWithoutSaving: 'Dupliser uten å lagre endringer',
    edit: 'Redigere',
    editAll: 'Rediger alle',
    editedSince: 'Redigert siden',
    editing: 'Redigerer',
    editingLabel_many: 'Redigerer {{count}} {{label}}',
    editingLabel_one: 'Redigerer {{count}} {{label}}',
    editingLabel_other: 'Redigerer {{count}} {{label}}',
    editingTakenOver: 'Redigering overtatt',
    editLabel: 'Rediger {{label}}',
    email: 'E-post',
    emailAddress: 'E-postadresse',
    emptyTrash: 'Tøm søppelkassen',
    emptyTrashLabel: 'Tøm {{label}} søppel',
    enterAValue: 'Skriv inn en verdi',
    error: 'Feil',
    errors: 'Feil',
    exitLivePreview: 'Avslutt live forhåndsvisning',
    export: 'Eksport',
    fallbackToDefaultLocale: 'Tilbakestilling til standard språk',
    false: 'Falsk',
    filter: 'Filtrer',
    filters: 'Filter',
    filterWhere: 'Filtrer {{label}} der',
    globals: 'Globalt innhold',
    goBack: 'Gå tilbake',
    groupByLabel: 'Grupper etter {{label}}',
    import: 'Import',
    isEditing: 'redigerer',
    item: 'Vare',
    items: 'elementer',
    language: 'Språk',
    lastModified: 'Sist endret',
    leaveAnyway: 'Forlat likevel',
    leaveWithoutSaving: 'Forlat uten å lagre',
    light: 'Lys',
    livePreview: 'Forhåndsvisning',
    loading: 'Laster',
    locale: 'Språk',
    locales: 'Språk',
    menu: 'Meny',
    moreOptions: 'Flere alternativer',
    move: 'Flytt',
    moveConfirm:
      'Du er i ferd med å flytte {{count}} {{label}} til <1>{{destination}}</1>. Er du sikker?',
    moveCount: 'Flytt {{count}} {{label}}',
    moveDown: 'Flytt ned',
    moveUp: 'Flytt opp',
    moving: 'Flytting',
    movingCount: 'Flytter {{count}} {{label}}',
    newLabel: 'Ny {{label}}',
    newPassword: 'Nytt passord',
    next: 'Neste',
    no: 'Nei',
    noDateSelected: 'Ingen dato valgt',
    noFiltersSet: 'Ingen filtre satt',
    noLabel: '<Ingen {{label}}>',
    none: 'Ingen',
    noOptions: 'Ingen alternativer',
    noResults:
      'Ingen {{label}} funnet. Enten finnes det ingen {{label}} enda eller ingen matcher filterne du har spesifisert ovenfor.',
    notFound: 'Ikke funnet',
    nothingFound: 'Ingenting funnet',
    noTrashResults: 'Ingen {{label}} i søppelkassen.',
    noUpcomingEventsScheduled: 'Ingen kommende hendelser planlagt.',
    noValue: 'Ingen verdi',
    of: 'av',
    only: 'Bare',
    open: 'Åpne',
    or: 'Eller',
    order: 'Rekkefølge',
    overwriteExistingData: 'Overskriv eksisterende feltdata',
    pageNotFound: 'Siden ble ikke funnet',
    password: 'Passord',
    pasteField: 'Lim inn felt',
    pasteRow: 'Lim inn rad',
    payloadSettings: 'Payload-innstillinger',
    permanentlyDelete: 'Permanent slett',
    permanentlyDeletedCountSuccessfully: 'Permanent slettet {{count}} {{label}} med suksess.',
    perPage: 'Per side: {{limit}}',
    previous: 'Forrige',
    reindex: 'Reindekser',
    reindexingAll: 'Reindekserer alle {{collections}}.',
    remove: 'Fjern',
    rename: 'Endre navn',
    reset: 'Tilbakestill',
    resetPreferences: 'Tilbakestill preferanser',
    resetPreferencesDescription:
      'Dette vil tilbakestille alle preferansene dine til standardinnstillingene.',
    resettingPreferences: 'Tilbakestiller preferanser.',
    restore: 'Gjenopprett',
    restoreAsPublished: 'Gjenopprett som publisert versjon',
    restoredCountSuccessfully: 'Gjenopprettet {{count}} {{label}} vellykket.',
    restoring:
      'Respekter betydningen av den opprinnelige teksten innenfor konteksten av Payload. Her er en liste over vanlige Payload-uttrykk som har veldig spesifikke betydninger:\n    - Samling: En samling er en gruppe dokumenter som deler en felles struktur og formål. Samlinger brukes til å organisere og håndtere innhold i Payload.\n    - Felt: Et felt er et bestemt stykke data innenfor et dokument i en samling. Felt definerer strukturen og typen data som kan lagres i et dokument.\n    - Dokument: Et dokument er en individuell post innen',
    row: 'Rad',
    rows: 'Rader',
    save: 'Lagre',
    saving: 'Lagrer...',
    schedulePublishFor: 'Planlegg publisering for {{title}}',
    searchBy: 'Søk etter {{label}}',
    select: 'Velg',
    selectAll: 'Velg alle {{count}} {{label}}',
    selectAllRows: 'Velg alle rader',
    selectedCount: '{{count}} {{label}} valgt',
    selectLabel: 'Velg {{label}}',
    selectValue: 'Velg en verdi',
    showAllLabel: 'Vis alle {{label}}',
    sorryNotFound: 'Beklager, det er ingenting som samsvarer med forespørselen din.',
    sort: 'Sortér',
    sortByLabelDirection: 'Sorter etter {{label}} {{direction}}',
    stayOnThisPage: 'Bli på denne siden',
    submissionSuccessful: 'Innsending vellykket.',
    submit: 'Send inn',
    submitting: 'Innsending...',
    success: 'Suksess',
    successfullyCreated: '{{label}} ble opprettet.',
    successfullyDuplicated: '{{label}} ble duplisert.',
    successfullyReindexed:
      'Vellykket reindeksering av {{count}} av totalt {{total}} dokumenter fra {{collections}}, og {{skips}} utkast ble hoppet over.',
    takeOver: 'Ta over',
    thisLanguage: 'Norsk',
    time: 'Tid',
    timezone: 'Tidssone',
    titleDeleted: '{{label}} "{{title}}" ble slettet.',
    titleRestored: '{{label}} "{{title}}" ble gjenopprettet.',
    titleTrashed: '{{label}} "{{title}}" flyttet til søppel.',
    trash: 'Søppel',
    trashedCountSuccessfully: '{{count}} {{label}} flyttet til søppel.',
    true: 'Sann',
    unauthorized: 'Ikke autorisert',
    unsavedChanges: 'Du har ulagrede endringer. Lagre eller forkast før du fortsetter.',
    unsavedChangesDuplicate: 'Du har ulagrede endringer. Vil du fortsette å duplisere?',
    untitled: 'Uten tittel',
    upcomingEvents: 'Kommende hendelser',
    updatedAt: 'Oppdatert',
    updatedCountSuccessfully: 'Oppdaterte {{count}} {{label}} vellykket.',
    updatedLabelSuccessfully: 'Oppdatert {{label}} vellykket.',
    updatedSuccessfully: 'Oppdatert.',
    updateForEveryone: 'Oppdatering for alle',
    updating: 'Oppdatering',
    uploading: 'Opplasting',
    uploadingBulk: 'Laster opp {{current}} av {{total}}',
    user: 'Bruker',
    username: 'Brukernavn',
    users: 'Brukere',
    value: 'Verdi',
    viewing: 'Visning',
    viewReadOnly: 'Vis skrivebeskyttet',
    welcome: 'Velkommen',
    yes: 'Ja',
  },
  localization: {
    cannotCopySameLocale: 'Kan ikke kopiere til samme språk',
    copyFrom: 'Kopier fra',
    copyFromTo: 'Kopiering fra {{fra}} til {{til}}',
    copyTo: 'Kopier til',
    copyToLocale: 'Kopiere til språk',
    localeToPublish: 'Språk å publisere',
    selectedLocales: 'Valgte lokaliteter',
    selectLocaleToCopy: 'Velg språk for å kopiere',
    selectLocaleToDuplicate: 'Velg lokalinnstillinger for å duplisere',
  },
  operators: {
    contains: 'inneholder',
    equals: 'lik',
    exists: 'eksisterer',
    intersects: 'krysser',
    isGreaterThan: 'er større enn',
    isGreaterThanOrEqualTo: 'er større enn eller lik',
    isIn: 'er i',
    isLessThan: 'er mindre enn',
    isLessThanOrEqualTo: 'er mindre enn eller lik',
    isLike: 'er som',
    isNotEqualTo: 'er ikke lik',
    isNotIn: 'er ikke med',
    isNotLike: 'er ikke lik',
    near: 'nær',
    within: 'innen',
  },
  upload: {
    addFile: 'Legg til fil',
    addFiles: 'Legg til filer',
    bulkUpload: 'Bulk opplasting',
    crop: 'Beskjær',
    cropToolDescription:
      'Dra hjørnene av det valgte området, tegn et nytt område eller juster verdiene nedenfor.',
    download: 'Last ned',
    dragAndDrop: 'Dra og slipp en fil',
    dragAndDropHere: 'eller dra og slipp en fil her',
    editImage: 'Rediger bilde',
    fileName: 'Filnavn',
    fileSize: 'Filstørrelse',
    filesToUpload: 'Filer til opplasting',
    fileToUpload: 'Fil til opplasting',
    focalPoint: 'Fokuspunkt',
    focalPointDescription:
      'Dra fokuspunktet direkte på forhåndsvisningen eller juster verdiene nedenfor.',
    height: 'Høyde',
    lessInfo: 'Mindre info',
    moreInfo: 'Mer info',
    noFile: 'Ingen fil',
    pasteURL: 'Lim inn URL',
    previewSizes: 'Forhåndsvisningsstørrelser',
    selectCollectionToBrowse: 'Velg en samling å bla i',
    selectFile: 'Velg en fil',
    setCropArea: 'Angi beskjæringsområde',
    setFocalPoint: 'Angi fokuspunkt',
    sizes: 'Størrelser',
    sizesFor: 'Størrelser for {{label}}',
    width: 'Bredde',
  },
  validation: {
    emailAddress: 'Vennligst skriv inn en gyldig e-postadresse.',
    enterNumber: 'Vennligst skriv inn et gyldig tall.',
    fieldHasNo: 'Dette feltet har ingen {{label}}',
    greaterThanMax: '{{value}} er større enn den tillatte maksimale {{label}} på {{max}}.',
    invalidBlock: 'Blokken "{{block}}" er ikke tillatt.',
    invalidBlocks: 'Dette feltet inneholder blokker som ikke lenger er tillatt: {{blocks}}.',
    invalidInput: 'Dette feltet har en ugyldig inndata.',
    invalidSelection: 'Dette feltet har en ugyldig utvalg.',
    invalidSelections: 'Dette feltet har følgende ugyldige utvalg:',
    latitudeOutOfBounds: 'Breddegrad må være mellom -90 og 90.',
    lessThanMin: '{{value}} er mindre enn den tillatte minimale {{label}} på {{min}}.',
    limitReached: 'Begrensning nådd, bare {{max}} elementer kan legges til.',
    longerThanMin: 'Denne verdien må være lengre enn minimumslengden på {{minLength}} tegn.',
    longitudeOutOfBounds: 'Lengdegrad må være mellom -180 og 180.',
    notValidDate: '"{{value}}" er ikke en gyldig dato.',
    required: 'Dette feltet er påkrevd.',
    requiresAtLeast: 'Dette feltet krever minst {{count}} {{label}}.',
    requiresNoMoreThan: 'Dette feltet krever maksimalt {{count}} {{label}}.',
    requiresTwoNumbers: 'Dette feltet krever to tall.',
    shorterThanMax: 'Denne verdien må være kortere enn maksimal lengde på {{maxLength}} tegn.',
    timezoneRequired: 'En tidssone er nødvendig.',
    trueOrFalse: 'Dette feltet kan bare være likt true eller false.',
    username:
      'Vennligst oppgi et gyldig brukernavn. Kan inneholde bokstaver, nummer, bindestreker, punktum og understrek.',
    validUploadID: 'Dette feltet er ikke en gyldig opplastings-ID.',
  },
  version: {
    type: 'Type',
    aboutToPublishSelection:
      'Du er i ferd med å publisere alle {{label}} i utvalget. Er du sikker?',
    aboutToRestore:
      'Du er i ferd med å gjenopprette {{label}} dokumentet til tilstanden det var i på {{versionDate}}.',
    aboutToRestoreGlobal:
      'Du er i ferd med å gjenopprette det globale innholdet {{label}} til tilstanden det var i på {{versionDate}}.',
    aboutToRevertToPublished:
      'Du er i ferd med å tilbakestille endringene i dette dokumentet til den publiserte tilstanden. Er du sikker?',
    aboutToUnpublish: 'Du er i ferd med å avpublisere dette dokumentet. Er du sikker?',
    aboutToUnpublishSelection:
      'Du er i ferd med å oppheve publiseringen av alle {{label}} i utvalget. Er du sikker?',
    autosave: 'Lagre automatisk',
    autosavedSuccessfully: 'Lagret automatisk.',
    autosavedVersion: 'Automatisk lagret versjon',
    changed: 'Endret',
    changedFieldsCount_one: '{{count}} endret felt',
    changedFieldsCount_other: '{{count}} endrede felt',
    compareVersion: 'Sammenlign versjon mot:',
    compareVersions: 'Sammenlign versjoner',
    comparingAgainst: 'Sammenligner mot',
    confirmPublish: 'Bekreft publisering',
    confirmRevertToSaved: 'Bekreft tilbakestilling til lagret',
    confirmUnpublish: 'Bekreft avpublisering',
    confirmVersionRestoration: 'Bekreft versjon-gjenoppretting',
    currentDocumentStatus: 'Nåværende {{docStatus}} dokument',
    currentDraft: 'Nåværende utkast',
    currentlyPublished: 'For tiden publisert',
    currentlyViewing: 'Ser på for øyeblikket',
    currentPublishedVersion: 'Nåværende publiserte versjon',
    draft: 'Utkast',
    draftHasPublishedVersion: 'Utkast (har publisert versjon)',
    draftSavedSuccessfully: 'Utkast lagret.',
    lastSavedAgo: 'Sist lagret {{distance}} siden',
    modifiedOnly: 'Kun endret',
    moreVersions: 'Flere versjoner...',
    noFurtherVersionsFound: 'Ingen flere versjoner funnet',
    noLabelGroup: 'Gruppe uten navn',
    noRowsFound: 'Ingen {{label}} funnet',
    noRowsSelected: 'Ingen {{label}} valgt',
    preview: 'Forhåndsvisning',
    previouslyDraft: 'Tidligere utkast',
    previouslyPublished: 'Tidligere publisert',
    previousVersion: 'Tidligere versjon',
    problemRestoringVersion: 'Det oppstod et problem med gjenoppretting av denne versjonen',
    publish: 'Publisere',
    publishAllLocales: 'Publiser alle språk',
    publishChanges: 'Publiser endringer',
    published: 'Publisert',
    publishIn: 'Publiser på {{locale}}',
    publishing: 'Publisering',
    restoreAsDraft: 'Gjenopprett som utkast',
    restoredSuccessfully: 'Gjenopprettet.',
    restoreThisVersion: 'Gjenopprett denne versjonen',
    restoring: 'Gjenoppretter...',
    reverting: 'Tilbakestiller...',
    revertToPublished: 'Tilbakestill til publisert',
    saveDraft: 'Lagre utkast',
    scheduledSuccessfully: 'Planlegging vellykket.',
    schedulePublish: 'Planlegg publisering',
    selectLocales: 'Velg språk å vise',
    selectVersionToCompare: 'Velg en versjon å sammenligne',
    showingVersionsFor: 'Viser versjoner for:',
    showLocales: 'Vis språk:',
    specificVersion: 'Spesifikk versjon',
    status: 'Status',
    unpublish: 'Avpubliser',
    unpublishing: 'Avpubliserer...',
    version: 'Versjon',
    versionAgo: '{{distance}} siden',
    versionCount_many: '{{count}} versjoner funnet',
    versionCount_none: 'Ingen versjoner funnet',
    versionCount_one: '{{count}} versjon funnet',
    versionCount_other: '{{count}} versjoner funnet',
    versionID: 'Versjons-ID',
    versions: 'Versjoner',
    viewingVersion: 'Viser versjon for {{entityLabel}} {{documentTitle}}',
    viewingVersionGlobal: 'Viser versjon for det globale innholdet {{entityLabel}}',
    viewingVersions: 'Viser versjoner for {{entityLabel}} {{documentTitle}}',
    viewingVersionsGlobal: 'Viser versjoner for det globale innholdet {{entityLabel}}',
  },
}

export const nb: Language = {
  dateFNSKey: 'nb',
  translations: nbTranslations,
}
